import { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import IosShareIcon from "@mui/icons-material/IosShare.js";
import { Box, CardContent, CardHeader, Typography } from "@mui/material";
import Link from "@mui/material/Link";
import GoogleIcon from "@mui/icons-material/Google.js";
import AppleIcon from "@mui/icons-material/Apple.js";
import { copyToClipboard } from "./Event.jsx";
import { display24HourTime } from "../shared/date.js";
import { toSlots } from "../shared/class/event.ts";
import { appleMap, googleMap } from "../shared/venue.ts";
import TipBox from "./TipBox.jsx";

const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST;

export const EventCard = (props) => {
    const { venue: eventVenue, date, event_artists, event_instructors, ...event } = props.event;
    const [venue, setVenue] = useState(eventVenue || null);

    useEffect(() => {
        const fetchVenue = async () => {
            if (!eventVenue?.venueKey) return;
            try {
                const res = await fetch(`${BACKEND_HOST}/venues?filters[venueKey][$eq]=${encodeURIComponent(eventVenue.venueKey)}`);
                const data = await res.json();
                if (data.data && data.data.length > 0) {
                    setVenue(data.data[0].attributes || data.data[0]);
                }
            } catch (err) {
                // Optionally handle error
            }
        };
        fetchVenue();
    }, [eventVenue?.venueKey]);

    const href = `https://austin2step.com/event/${venue?.venueKey || eventVenue?.venueKey}/${date}`;
    const slots = toSlots(
        event_artists || [],
        event_instructors || []
    );

    if (!venue) return null;

    return (
        <Card>
            <Button onClick={e => copyToClipboard(e, href)} href={href} size={"small"} style={{ float: "right", margin: "20px" }} variant="contained" endIcon={<IosShareIcon />}>Share</Button>
            <CardHeader title={venue.name} subheader={venue.location} />
            <CardContent>
                <div>
                    <Typography variant={"overline"}>Lineup for {date}</Typography>
                </div>
                <div style={{ paddingBottom: "20px" }}>
                    <div>
                        {slots.map((slot, i) => <div key={i}>
                            <strong style={{ paddingRight: "5px" }}>{display24HourTime(slot.time)}</strong>
                            {slot?.artist?.danceable ?
                                <strong><Link href={"/artist/" + slot?.artist?.artistKey}>{slot?.title}</Link></strong> : slot.title}
                            {slots.venmo && <TipBox artist={slot?.artist} />}
                        </div>)}
                    </div>
                    <div style={{ marginTop: "20px" }}>
                        <Typography variant={"overline"}>Getting Here</Typography>
                    </div>
                    <div><small>{venue.address}</small></div>
                    <div><small>{venue.city}, {venue.state} {venue.zip}</small></div>
                    <Box pt={2}>
                        <Button size={"small"} startIcon={<GoogleIcon />} href={googleMap(venue)} variant={"outlined"} target="_blank">Maps</Button>
                        &nbsp; &nbsp; &nbsp;
                        <Button size={"small"} startIcon={<AppleIcon />} href={appleMap(venue)} variant={"outlined"} target="_blank">Maps</Button>
                    </Box>
                    <div style={{ marginTop: "20px" }}>
                        <Typography variant={"overline"}>Other</Typography>
                    </div>
                    <div><small>Cover: {venue.cover}</small></div>
                    <div><small>Ages: {venue.age}</small></div>
                </div>
            </CardContent>
        </Card>
    );
};